<template>
  <div class="ad-page">
    <!-- 权限管理 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="角色名:">
          <el-input v-model="searchValue.role_name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="searchUsersList"
            >查询</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button type="success" plain @click="privilegeAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 权限管理列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="角色ID"> </el-table-column>
      <el-table-column prop="role_name" label="角色名称"> </el-table-column>
      <el-table-column prop="game" label="游戏名称">
        <template slot-scope="scope">
          <p class="ellipsis">{{ scope.row.game }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="channel" label="渠道包名称">
        <template slot-scope="scope">
          <p class="ellipsis">{{ scope.row.channel }}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <router-link
            :to="{
              name: 'privilegeEdit',
              query: {
                id: scope.row.id,
                role_name: scope.row.role_name,
                menu_ids: scope.row.menu_ids,
                game_ids: scope.row.game_ids,
                channel_ids: scope.row.channel_ids,
                display_list: scope.row.display_list,
                display_channel: scope.row.display_channel,
                display_game: scope.row.display_game,
                export: scope.row.export,
                game_channel_package_ids: scope.row.game_channel_package_ids,
              },
            }"
          >
            <el-button
              type="warning"
              icon="el-icon-edit"
              plain
              circle
              style="margin-right: 10px"
            ></el-button>
          </router-link>
          <el-button
            type="primary"
            icon="el-icon-document-copy"
            plain
            circle
            title="复制"
            @click="copyPrivilege(scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            plain
            circle
            @click="del_privilege(scope.row.id)"
          ></el-button>
          <el-button
            type="danger"
            plain
            size="mini"
            @click="del_channel_privilege(scope.row.id)"
          >删除渠道</el-button>
          <!-- <el-button
            type="primary"
            plain
            @click="onTransition(scope.row.id)"
          >渠道转换</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { throttle, urlSplicing } from "@/assets/js/public.js";
var refreshFlag = false;
export default {
  name: "privilegeList",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        role_name: "",
      },
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  created() {
    this.getprivilegeList(true);
  },
  computed: {
    ...mapState(["host"]),
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 120; //减去页面上固定高度height
  },
  watch: {
    $route(to, from) {
      if (from.name == "privilegeAdd" || from.name == "privilegeEdit") {
        this.getprivilegeList();
      }
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getprivilegeList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getprivilegeList(false);
    },
    // 实现员工管理数据搜索
    searchUsersList() {
      this.currentPage = 1;
      this.getprivilegeList(true);
    },
    privilegeAdd() {
      this.$router.push("/home/privilegeAdd");
    },
    copyPrivilege(row) {
      this.$router.push({
        name: "privilegeAdd",
        query: {
          copy_id: row.id,
          menu_ids: row.menu_ids,
          game_ids: row.game_ids,
          channel_ids: row.channel_ids,
          display_list: row.display_list,
          display_channel: row.display_channel,
          display_game: row.display_game,
          export: row.export,
          game_channel_package_ids: row.game_channel_package_ids,
          field: row.field,
        },
      });
    },

    // 删除
    del_privilege(id) {
      fetch({
        url: "/admin/admin_privileges/privilege_del",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getprivilegeList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 删除渠道
    del_channel_privilege(id) {
      fetch({
        url: "/admin/admin_privileges/privilege_del",
        method: "GET",
        params: {
          id: id,
          channel: 1,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getprivilegeList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 渠道转换
    onTransition(id) {
      fetch({
        url: "/admin/admin_privileges/transition",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "转换成功！",
          });
          this.getprivilegeList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 展示权限列表数据
    getprivilegeList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/admin_privileges/privilege_list",
        method: "GET",
        params: {
          ...searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
          // uid: searchValue.id,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
            // let that = this
            // that.tableData =[]
            // Object.keys(res.data.data).forEach((value, key) => {
            //   that.tableData.push(res.data.data[value]);
            // });
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
